<template>
 <div  v-if="hasRole(roles.RW_REAL_ESTA_CRED)">
    <div class="d-flex " v-if="!flDetails">
    <div class="col-md-3">
    <comissoesTotal :key="keyTotal"></comissoesTotal>
    <formSearchComission v-on:SearchItems="GetFilter"></formSearchComission>
  </div>
  <div class="col-md-9">
    <tableComission ref="tableCommissionCheck" :key="tablereload" v-on:edit="edit" v-on:deleteCommission="deleteCommission"></tableComission>
  </div>
</div>
  <Commissiondetails :dataDetails="selectedComissao" v-if="flDetails" ></Commissiondetails>
 </div>

</template>

<script>
import commissioncheck from '@/views/private/realestate/commissioncheck/commissioncheck'
export default commissioncheck
</script>

<style scoped>
#card-sales{
  height: 100%;
  width: 100%;
  padding: 15px;
  border: 1px solid rgb(180, 180, 180);
  background-color: white;
}

.tabledata{
font: normal normal normal 15px/20px Segoe UI;
letter-spacing: 0px;
color: #656565;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissioncheck/commissioncheck.vue